module.exports = __webpack_public_path__ + "static/media/newmessage.1c338f63.png";